var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('personal-info-details',{attrs:{"application":_vm.application,"requirement":_vm.requirement,"actions":_vm.actions,"requirement-value":_vm.requirementFulfillment.requirementValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }